import { CASES } from "@/lib/data";

const items = [...CASES, ...CASES].map((c) => c.name);

export const ClientLogos = () => {
  return (
    <section className="py-14 border-y border-white/5 bg-white/[0.015]">
      <div className="mx-auto max-w-7xl px-5 lg:px-10 mb-8">
        <p className="text-center text-xs uppercase tracking-[0.28em] text-white/45">
          Nogle af de virksomheder vi har arbejdet med
        </p>
      </div>
      <div className="marquee-mask overflow-hidden">
        <div className="marquee-track flex gap-14 whitespace-nowrap min-w-[200%]">
          {items.map((name, i) => (
            <span
              key={i}
              className="font-display text-2xl sm:text-3xl font-semibold text-white/40 hover:text-white transition-colors duration-300"
              data-testid={`client-logo-${i}`}
            >
              {name}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
};
